var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.meetings.length
    ? _c(
        "action-card",
        {
          attrs: {
            title: _vm.$t("nav.meetings"),
            icon: "users-round",
            count: _vm.meetings.length
          },
          on: {
            open: function($event) {
              return _vm.$router.push("/meetings/booked")
            }
          }
        },
        _vm._l(_vm.visibleMeetings, function(meeting) {
          return _c(
            "button",
            {
              key: meeting.id,
              staticClass: "portal-action-row",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.openScheduledMeeting(meeting)
                }
              }
            },
            [
              _c("span", { staticClass: "action-row-copy" }, [
                _c("strong", [_vm._v(_vm._s(meeting.meetingName))]),
                _c("small", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("global.on")) +
                      " " +
                      _vm._s(
                        _vm.DateTime.fromISO(
                          meeting.confirmedTime.start
                        ).toFormat("MMM dd @ hh:mma")
                      ) +
                      " "
                  )
                ])
              ]),
              _c("portal-icon", { attrs: { name: "chevron-right", size: 18 } })
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }